import React from 'react';
import classNames from 'classnames';

interface ComponentProps {
  text: string;
  className?: string;
  dataCy?: string;
}

// One line of cell text, cut short with an ellipsis when the column is too narrow, with the full text
// on hover (see .sah-care-recipient-text in _configs.scss).
const TruncatedCell: React.FC<ComponentProps> = ({ text, className, dataCy }) => (
  <span className={classNames('sah-care-recipient-text', className)} title={text} data-cy={dataCy}>
    {text}
  </span>
);

export default TruncatedCell;
